import './EditText.css';

import { InputAdornment, TextField, MenuItem } from '@mui/material';
import React from 'react';
import { generateClassName, handleObjectFieldChange } from './helpers';
import { getNestedProperty } from './B2BElementsExplorer';

const EditText = ({ object, objectField, setObjectField, suffix = null, className = null, readOnly = false, onChange = null, type = 'text', minValue = null, maxValue = null, options = [], ...rest }) => {
    const handleChange = (event) => {
        if (!readOnly) {
            let value = event.target.value;
            if (type === 'number') {
                value = Number(value);
                if (minValue !== null && value < minValue) {
                    value = minValue;
                }
                if (maxValue !== null && value > maxValue) {
                    value = maxValue;
                }
            }
            handleObjectFieldChange(objectField, value, setObjectField);
            if (onChange) {
                onChange(value);
            }
        }
    };

    return (
        <TextField
            variant='standard'
            value={getNestedProperty(object, objectField)}
            onChange={handleChange}
            type={type}
            select={options.length > 0}
            InputProps={suffix && {
                readOnly: readOnly,
                endAdornment: <InputAdornment position="start">{suffix}</InputAdornment>,
            }}
            className={`b2b-edit-text ${generateClassName('edit-text-', objectField, className)}`}
            {...rest}
        >
            {options.length > 0 && options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default EditText;